import { DropDownOption } from '../interfaces/drop-down-option.interface';

export const RATE_INTERPOLATION: DropDownOption[] = [
  { id: 'NONE', displayValue: 'None' },
  { id: 'FIRST_PERIOD', displayValue: 'First Period' },
  { id: 'LAST_PERIOD', displayValue: 'Last Period' },
  { id: 'FIRST_AND_LAST', displayValue: 'First and Last' },
];
